import { Page } from "@iq/models";

function Invoices() {
	return (
		<Page>
		</Page>
	);
}


export default Invoices;